import { Controller, useForm } from 'react-hook-form';
import { RadioGroup, RadioGroupItem } from 'src/components/ui/radio-group';
import { yupResolver } from '@hookform/resolvers/yup';
import { object } from 'yup';
import { stringScheme } from 'src/utils/validation-schemes';
import { Button } from 'src/components/ui/button';
import ArrowLargeIcon from 'src/assets/img/arrow-large-icon.svg';
import type { ZendeskIntegrationType } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateZendeskIntegrationPopup/ZendeskIntegrationForm2/ZendeskIntegrationForm2';

const INTEGRATION_TYPES = [
  { value: 'Help Center', id: 'help-center', label: 'Help Center articles' },
  { value: 'Tickets', id: 'tickets', label: 'Tickets' },
];

export const ZendeskIntegrationForm1 = ({
  zendeskIntegrationType,
  nextStep,
  closePopup,
}: {
  zendeskIntegrationType: ZendeskIntegrationType;
  nextStep: (data: { zendeskIntegrationType: ZendeskIntegrationType }) => void;
  closePopup: () => void;
}) => {
  const submit = (data: { zendeskIntegrationType: ZendeskIntegrationType }) => {
    nextStep(data);
  };

  const close = () => {
    closePopup();
  };

  const { handleSubmit, control } = useForm({
    defaultValues: {
      zendeskIntegrationType: zendeskIntegrationType,
    },
    resolver: yupResolver(
      object({
        zendeskIntegrationType: stringScheme({ required: false }).label('Zendesk Integration Type'),
      }),
    ),
  });

  return (
    <form
      onSubmit={handleSubmit(submit)}
      id="zendesk-integration-form-1"
      className={'h-full flex flex-col justify-between px-4'}
    >
      <Controller
        control={control}
        name="zendeskIntegrationType"
        render={({ field: { onChange, value } }) => (
          <RadioGroup onValueChange={onChange} defaultValue={value} className="flex flex-col gap-3">
            {INTEGRATION_TYPES.map((type) => (
              <label
                key={type.id}
                htmlFor={type.id}
                className={
                  'flex cursor-pointer items-center gap-3 rounded-lg border border-grey_300 bg-white p-3 transition-colors hover:border-green_750 has-[[data-state=checked]]:border-green_750 has-[[data-state=checked]]:shadow-[0_0_3px_0_rgba(96,235,139,0.2)]'
                }
              >
                <span className={'flex-1 text-sm font-medium text-grey_750'}>{type.label}</span>
                <RadioGroupItem
                  value={type.value}
                  id={type.id}
                  className={'border-grey_300 text-green_750 data-[state=checked]:border-green_750'}
                />
              </label>
            ))}
          </RadioGroup>
        )}
      />
      <div className="flex justify-center gap-2 mt-5">
        <Button variant="tertiary" type="button" className="w-[100px]" onClick={close}>
          Cancel
        </Button>
        <Button variant="dark" type="submit" className="w-[100px]">
          {'Next'}
          <img src={ArrowLargeIcon} alt={''} width={16} height={16} />
        </Button>
      </div>
    </form>
  );
};
